<template>
  <div class="t-page_articles t-work-area">
    <h1>{{ pageText.title }}</h1>
    <form class="t-articles-search t-search" @submit.prevent="Submit">
      <div class="t-input">
        <input v-model="search" :placeholder="pageText.placeholder" class="_border">
        <transition name="fade">
          <span class="t-search__clear" v-if="search !== ''" @click.stop.prevent="Clear()">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L13 13M13 1L1 13" stroke="#52A8F2" stroke-width="2"/>
            </svg>
          </span>
        </transition>
        <button class="t-search__submit">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 5.5C12 7.43311 10.4331 9 8.5 9C6.56689 9 5 7.43311 5 5.5C5 3.56689 6.56689 2 8.5 2C10.4331 2 12 3.56689 12 5.5ZM14 5.5C14 8.5376 11.5376 11 8.5 11C7.34253 11 6.26831 10.6426 5.38232 10.0317L1.70703 13.707C1.31665 14.0977 0.68335 14.0977 0.292969 13.707C-0.0976562 13.3167 -0.0976562 12.6833 0.292969 12.293L3.96826 8.61768C3.35742 7.73169 3 6.65747 3 5.5C3 2.4624 5.4624 0 8.5 0C11.5376 0 14 2.4624 14 5.5Z" :fill="color" :fill-opacity="opacity"/>
          </svg>
        </button>
      </div>
      <button class="t-btn"><span>{{ pageText.search }}</span></button>
    </form>
    <cmp-articles></cmp-articles>
    <cmp-pagination class="t-pagination_center" v-if="articles._meta.pageCount > 1" :pages="articles._meta.pageCount"></cmp-pagination>
  </div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/articlesPage.json' : 'staticText',
        main: {
            title: "Статьи",
            placeholder: "Поиск по названиям, областям знаний, темам статей",
            search: "Поиск"
        }
    };

    import {store} from '../../store'

    import {mapGetters,mapActions} from 'vuex';

    import ArticlesList from '../../vue_components/ArticlesList.vue'
    import Pagination from '../../vue_components/Pagination.vue'

    export default {
        data(){
            return {
                pageText: {},

                search: ''
            }
        },
        computed: {
            ...mapGetters('articles', ['articles']),
            color(){
                return  this.search !== '' ? '#52A8F2' : '#84C1F6'
            },
            opacity(){
                return  this.search !== '' ? '1' : '0.4'
            }
        },
        components: {
            'cmp-articles': ArticlesList,
            'cmp-pagination': Pagination
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            ...mapActions('articles', ['LoadArticles']),
            Submit(){
                if(this.search !== ''){
                    this.$router.push({ name: this.$route.name, query: Object.assign({q: this.search}, {page: 1})});
                }
                else{
                    this.$router.push({ name: this.$route.name, query: Object.assign({page: 1})});
                }
            },
            Load(pageText){
                if(this.$route.query.q){
                    this.search = this.$route.query.q;
                }

                this.pageText = pageText;

                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 500)
            },
            Clear(){
                this.search = '';
                this.Submit();
            }
        },
        beforeRouteLeave (to, from, next) {
            this.UpdatePreloadState(true);
            next();
        },
        beforeRouteUpdate (to, from, next) {
            this.LoadArticles(to.query).then(() => {
                next()
            });
        },
        beforeRouteEnter (to, from, next) {
            let props = {};
            for(let key in to.query){
                props[key] = to.query[key]
            }
            if(props.page === undefined)
                props.page = 1;

            let count = 0;
            let pageText = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;

                count++;
                RunNext();
            });
            store.dispatch('articles/LoadArticles', props).then(() => {count++;RunNext();});
            let RunNext = () => {
                if(count > 1)
                    next(vm => vm.Load(pageText))
            }
        }
    }
</script>

<style lang="sass">
.t-page_articles.t-work-area
  a
    color: #52a8f2
  h1
    margin-bottom: 45px
  .t-articles-list
    margin-bottom: 42px
.t-articles-search
  max-width: 640px
  margin: 0 auto 64px
  display: flex
  align-items: center
  flex-direction: column
  .t-input
    margin-bottom: 39px
    position: relative
  svg
    position: absolute
    top: 14px
    right: 14px
</style>


// WEBPACK FOOTER //
// src/vue_pages/Articles/Index.vue